export default {
  header: 'Necesitamos verificar tu número de teléfono',
  buttons: {
    confirm: 'Confirmar',
  },
  toasts: {
    invalid_code: 'Código inválido. Por favor, inténtalo de nuevo.',
  },
};
